module.exports = __webpack_public_path__ + "static/media/bg-header-POMOZIBA.846a6d2f.png";